import {
  LinearProgress,
  Tooltip,
  IconButton,
  Icon,
  Stack,
  Button,
  Badge,
  Checkbox,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import MDTypography from "components/MDTypography";
import { centsToDollars } from "global/functions";
import MDBadge from "components/MDBadge";
import { dateToShow } from "global/functions";
import { useMaterialUIController } from "context";
import { get, isEmpty } from "lodash";
import MDBox from "components/MDBox";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubscriptionDuration } from "global/functions";
import ConfirmationDialog from "components/UIComponents/ConfirmationDialog";
import { paymentRefund } from "store/slice/payment/paymentSlice";
import CircularIndeterminate from "components/MDLoading";
import MDSnackbar from "components/MDSnackbar";
import { deleteSubscription } from "store/slice/subscriptions/subscriptionSlice";
import { mobileNumberMasking } from "global/functions";
import SubscriptionDetail from "./SubscriptionDetails";
import MDButton from "components/MDButton";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import { logout } from "store/slice/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { switchToParkerDashboard } from "store/slice/customer/customerSlice";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import PauseCircle from "@mui/icons-material/PauseCircle";
import PlayCircle from "@mui/icons-material/PlayCircle";
import SubscriptionChargeDialog from "./subscriptionChargeDialog";
import LicensePlatesDialog from "./LicensePlatesViewDialog";
import LicensePlateUpdateDialog from "./LicensePlateUpdateDialog";
import { sendPaymentLinkEmail } from "store/slice/subscriptions/subscriptionSlice";
import {
  updateCustomerEmailByEmail,
  getSubscriptionsByPlaceId,
  sendReminderEmail,
} from "store/slice/subscriptions/subscriptionSlice";
import DownloadIcon from "@mui/icons-material/Download";
import Label from "components/Common/Label";
import PauseDialog from "./subscriptionPauseDialog";
import MDDialog from "components/MDDialog";
import MDTextButton from "components/MDTextButton";
import CustomTooltip from "components/Common/CustomTooltip";
import moment from "moment";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { dockRevenueTransfer } from "store/slice/payment/paymentSlice";
import { getFullAddress } from "global/functions";

const SubscriptionsTable = (props) => {
  const [controller] = useMaterialUIController();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sidenavColor } = controller;
  const now = useMemo(() => new Date(), []);
  const upcomingEndDate = moment().add(3, "days");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [paymentLinkDialog, setPaymentLinkDialog] = useState({
    open: false,
    type: "email", // "email" or "sms"
    recipient: "",
  });
  const [reminderEmailDialogOpen, setReminderEmailDialogOpen] = useState(false);
  const [editEmailDialogOpen, setEditEmailDialogOpen] = useState(false);
  const [editEmailForm, setEditEmailForm] = useState({
    customerId: "",
    currentEmail: "",
    newEmail: "",
  });

  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [chargeDialogOpen, setChargeDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [licensePlateUpdateDialog, setLicensePlateUpdateDialog] =
    useState(false);
  const [licensePlateView, setLicensePlateView] = useState(false);
  const [licensePlates, setLicensePlates] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [subscriptionData, setSubscriptionData] = useState({});
  const { subscriptionList, subscriptionType, placeData, isLoading } = props;
  const [selectedSubscriptionIds, setSelectedSubscriptionIds] = useState([]);
  const [subscriptionPauseView, setSubscriptionPauseView] = useState(false);
  const [isSubscriptionPaused, setIsSubscriptionPaused] = useState(false);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });
  const [retryTransferDialog, setRetryTransferDialog] = useState(false);
  const [retryTransferData, setRetryTransferData] = useState({});

  const impersonateBy = localStorage.getItem("Authorization");
  const superAdmin = localStorage.getItem("ImpersonateBy");
  const userData = useSelector((state) => state.users?.meInfo);
  const selectedPlace = useSelector((state) => state.places?.selectedPlace);
  const roleLevel = userData?.roleLevel;
  const handelSwitch = (data) => {
    setLoading(true);
    const customerId = get(data, "customerId._id", false);
    dispatch(switchToParkerDashboard({ customerId }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(logout());
          localStorage.setItem("ImpersonateBy", impersonateBy);
          localStorage.setItem("CustomerAuthorization", res?.token);
          if (superAdmin) {
            localStorage.setItem("SuperAdmin", superAdmin);
          }
          navigate("/parker-login");
          setLoading(false);
        } else {
          setLoading(false);
          setNotification({
            ...notification,
            color: "error",
            title: "Error",
            content: res?.message,
            icon: "warning",
            show: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("error", err);
      });
  };

  const handleDownloadInvoice = (invoiceURL) => {
    if (invoiceURL) {
      window.open(invoiceURL, "_blank");
    }
  };

  const openEditEmailDialog = (row) => {
    const currentEmail = get(row, "customerId.email", "");
    const customerId = get(row, "customerId._id", "");
    setEditEmailForm({ customerId, currentEmail, newEmail: currentEmail });
    setEditEmailDialogOpen(true);
  };

  const handleEditEmailSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        customerId: editEmailForm.customerId,
        newEmail: editEmailForm.newEmail,
      };
      const res = await dispatch(updateCustomerEmailByEmail(payload)).unwrap();
      const success = res?.success;
      setNotification({
        ...notification,
        color: success ? "success" : "error",
        title: success ? "Success" : "Error",
        content: res?.message,
        icon: success ? "check" : "warning",
        show: true,
      });
      if (success && get(placeData, "_id", false)) {
        await dispatch(getSubscriptionsByPlaceId(placeData._id));
      }
      setEditEmailDialogOpen(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: err?.message || "Failed to update email",
        icon: "warning",
        show: true,
      });
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowIds = subscriptionList.map((row) => row._id);
      setSelectedSubscriptionIds(allRowIds);
      setIsSubscriptionPaused(
        subscriptionList?.[0]?.isSubscriptionPaused || false,
      );
    } else {
      setSelectedSubscriptionIds([]);
    }
  };

  const handelRetryDockRevenueTransfer = async () => {
    try {
      setLoading(true);

      const payload = {
        paymentIntentId: retryTransferData?.paymentId?.transactionId,
      };

      const res = await dispatch(dockRevenueTransfer(payload)).unwrap();

      const success = res?.success;

      if (success) {
        await dispatch(
          getSubscriptionsByPlaceId(placeData?._id || placeData?.placeId),
        );
      }

      setNotification({
        ...notification,
        color: success ? "success" : "error",
        title: success ? "Success" : "Error",
        content: res?.message,
        icon: success ? "check" : "warning",
        show: true,
      });

      setRetryTransferDialog(false);
      setRetryTransferData({});
      setLoading(false);
    } catch (err) {
      console.log("Retry transfer error", err);

      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: err?.message || "Failed to retry transfer",
        icon: "warning",
        show: true,
      });

      setLoading(false);
      setRetryTransferDialog(false);
    }
  };

  const handleSelectRow = (checked, rowId) => {
    if (checked) {
      setSelectedSubscriptionIds((prev) => [...prev, rowId]);
      const subscriptionStatus = subscriptionList.find(
        (row) => row._id === rowId,
      );
      setIsSubscriptionPaused(subscriptionStatus.isSubscriptionPaused || false);
    } else {
      setSelectedSubscriptionIds((prev) => prev.filter((id) => id !== rowId));
    }
  };

  const getRequiredActions = useCallback(
    (row) => {
      let actions = [];

      if (row.isReactivationRequested) actions.push("Reactivation Request");
      if (row.isSubscriptionPaused) actions.push("Paused Subscription");
      if (row.subscriptionStatus === "initialize")
        actions.push("Pending Payment");
      if (row.licensePlate?.some((p) => p.status === 1))
        actions.push("Pending License Plate");
      if (row.licensePlateGetUpdated) actions.push("License Plate Updated");
      // if (row.subscriptionStatus === "failed") actions.push("Failed Payment");

      if (
        row.isAutoRenew &&
        !row.isSubscriptionPaused &&
        new Date(row.endDate) < now &&
        !["pending", "initialize"].includes(row.subscriptionStatus)
      ) {
        actions.push("Expired Auto-Renew");
      }

      if (
        row.subscriptionStatus === "active" &&
        row.isAutoRenew &&
        moment(row.endDate).isBetween(moment(), upcomingEndDate, "day", "[]")
      ) {
        actions.push("Upcoming Renewal");
      }

      return actions;
    },
    [now, upcomingEndDate],
  );

  const columnsData = [
    ...(subscriptionType === "active" ||
    subscriptionType === "paused" ||
    subscriptionType === "actionRequired"
      ? [
          {
            field: "SelectAll",
            headerName: "Select All",
            width: 120,
            renderHeader: () => {
              const allSelected =
                subscriptionList.length > 0 &&
                selectedSubscriptionIds.length === subscriptionList.length;

              const isIndeterminate =
                selectedSubscriptionIds.length > 0 &&
                selectedSubscriptionIds.length < subscriptionList.length;

              return (
                <div>
                  <Checkbox
                    checked={allSelected}
                    indeterminate={isIndeterminate}
                    onChange={(event) => handleSelectAll(event.target.checked)}
                    inputProps={{ "aria-label": "Select all rows" }}
                  />
                  <Label variant="outlined">Select All</Label>
                </div>
              );
            },
            renderCell: (params) => {
              const row = params.row;

              const requiredActions =
                subscriptionType === "actionRequired"
                  ? getRequiredActions(row)
                  : [];

              const tooltipText =
                requiredActions.length > 0
                  ? `Action Needed: ${requiredActions.join(" | ")}`
                  : "";

              return (
                <Stack direction="row" alignItems="center">
                  <Checkbox
                    checked={selectedSubscriptionIds.includes(row._id)}
                    onChange={(event) =>
                      handleSelectRow(event.target.checked, row._id)
                    }
                    inputProps={{ "aria-label": "Select row" }}
                  />

                  {subscriptionType === "actionRequired" &&
                    requiredActions.length > 0 && (
                      <MDBox mt={0.5}>
                        <CustomTooltip
                          id={`tooltip-${row._id}`}
                          title={tooltipText}
                          openTooltipId={openTooltipId}
                          setOpenTooltipId={setOpenTooltipId}
                          iconVariant="outlined"
                          iconSize={18}
                        />
                      </MDBox>
                    )}
                </Stack>
              );
            },
          },
        ]
      : []),
    {
      field: "subscriptionNumber",
      headerName: "Subscription ID",
      width: 120,
      editable: false,
      renderCell: ({ row }) => {
        let color;
        switch (row.subscriptionStatus) {
          case "failed":
            color = "red";
            break;
          case "refunded":
            color = "#1b6be4";
            break;
          case "cancel":
            color = "#f5b642";
            break;
          default:
            color = "default";
            break;
        }

        const hasPendingPlates = row.licensePlate?.some((p) => p.status === 1);
        const hasPlateUpdates = row.licensePlateGetUpdated;

        return (
          <>
            <IconButton
              onClick={() => {
                setSubscriptionData(row);
                setLicensePlateUpdateDialog(true);
              }}
            >
              <MDBox sx={{ position: "relative", display: "inline-block" }}>
                {(hasPlateUpdates || hasPendingPlates) && (
                  <Tooltip
                    title={
                      hasPlateUpdates
                        ? "Updates in license plate"
                        : "Pending license plate"
                    }
                    placement="top"
                  >
                    <Badge
                      badgeContent=""
                      color={hasPlateUpdates ? "success" : "info"}
                      anchorOrigin={{ vertical: "top", horizontal: "left" }}
                      sx={{
                        position: "absolute",
                        left: "-5px",
                        top: "-15px",
                      }}
                    />
                  </Tooltip>
                )}
              </MDBox>
            </IconButton>
            <IconButton
              onClick={() => {
                setSubscriptionData(row);
                setChargeDialogOpen(true);
              }}
            >
              <MDBox sx={{ position: "relative", display: "inline-block" }}>
                {row.isReactivationRequested && (
                  <Tooltip title="Reactivation Request" placement="top">
                    <Badge
                      badgeContent=""
                      color="warning"
                      anchorOrigin={{ vertical: "top", horizontal: "left" }}
                      sx={{
                        position: "absolute",
                        left:
                          hasPlateUpdates || hasPendingPlates ? "15px" : "-5px",
                        top: "-15px",
                      }}
                    />
                  </Tooltip>
                )}
              </MDBox>
            </IconButton>
            <MDTypography component="span" variant="caption" style={{ color }}>
              {row.subscriptionNumber || "-"}
            </MDTypography>
          </>
        );
      },
    },
    ...(subscriptionType !== "pending" && subscriptionType !== "refunded"
      ? [
          {
            field: "firstStartDate",
            headerName: "First Start Date",
            width: 150,
            editable: false,
            renderCell: ({ row }) => (
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {dateToShow(row.createdAt)}
              </MDTypography>
            ),
          },
          {
            field: "paymentMethodType",
            headerName: "Payment Method",
            width: 150,
            editable: false,
            renderCell: ({ row }) => (
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {row.paymentMethodType === "card"
                  ? "Credit card"
                  : row.paymentMethodType === "ACH"
                    ? "ACH"
                    : row.paymentMethodType}
              </MDTypography>
            ),
          },
        ]
      : []),

    {
      field: "duration",
      headerName: "Duration",
      width: 180,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption">
          {getSubscriptionDuration({
            startDate: row.startDate,
            endDate: row.endDate,
            tz: row?.placeId?.timeZoneId,
          })}
        </MDTypography>
      ),
    },
    ...(subscriptionType === "canceled"
      ? [
          {
            field: "subscriptionCancelDate",
            headerName: "Cancel On",
            width: 150,
            editable: false,
            renderCell: ({ row }) => (
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {dateToShow(row.subscriptionCancelDate)}
              </MDTypography>
            ),
          },
        ]
      : []),
    {
      field: "licensePlate",
      headerName: "License Plates",
      width: 170,
      editable: false,
      renderCell: ({ row }) => {
        const activePlates =
          row.licensePlate?.filter((obj) => obj.status === 10) || [];
        return (
          <>
            <div>
              <MDBadge
                badgeContent={`${row.licensePlate?.[0]?.licensePlateNumber || "-"}`}
                color={sidenavColor}
                variant="gradient"
                size="sm"
                sx={{ marginRight: 1 }}
                max={9999999999}
              />
              {activePlates?.length > 1 && (
                <Button
                  color={sidenavColor}
                  sx={{ padding: 0 }}
                  disableRipple
                  onClick={() => {
                    setLicensePlateView(true);
                    setLicensePlates(activePlates);
                  }}
                >
                  ...
                  {activePlates?.length - 1}
                  more
                </Button>
              )}
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 180,
      editable: false,
      renderCell: ({ row }) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {` ${row.customerId?.email || "-"}`}
          </MDTypography>
          <Tooltip title={`Edit Email`} placement="top">
            <IconButton
              color="primary"
              size="small"
              onClick={() => openEditEmailDialog(row)}
            >
              <Icon sx={{ fontSize: 18 }}>edit</Icon>
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
    {
      field: "cellPhone",
      headerName: "Cell Phone",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${
            row.customerId?.isEmailPrimary
              ? row.customerId?.secondaryMobile &&
                row.customerId?.secondaryMobile !== "N/A"
                ? mobileNumberMasking(row.customerId.secondaryMobile)
                : "-"
              : row.customerId?.mobile
                ? mobileNumberMasking(row.customerId.mobile)
                : "-"
          }`}
        </MDTypography>
      ),
    },

    {
      field: "name",
      headerName: "Name",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.customerId?.firstName || ""} ${
            row.customerId?.lastName || ""
          }`}
        </MDTypography>
      ),
    },
    {
  field: "address",
  headerName: "Address",
  width: 250,
  editable: false,
  renderCell: ({ row }) => (
    <MDTypography
      display="block"
      variant="caption"
      sx={{
        color: "black.light",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        lineHeight: 1.4,
      }}
    >
      {row.address ? getFullAddress(row.address) : "-"}
    </MDTypography>
  ),
},

    {
      field: "subscriptionType",
      headerName: "Subscription Type",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.isMonthly ? "Monthly" : "Custom"}
        </MDTypography>
      ),
    },
    {
      field: "isDirectChargeSubscription",
      headerName: "Direct Charge",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.isDirectChargeSubscription ? "Yes" : "No"}
        </MDTypography>
      ),
    },
    {
      field: "isAutoRenew",
      headerName: "Is Auto Renew",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.isAutoRenew ? "Yes" : "No"}
        </MDTypography>
      ),
    },

    {
      field: "baseRate",
      headerName: "Base Rate",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.baseRate !== row?.firstMonthBaseRate ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.baseRate)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthBaseRate)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.baseRate)}`}
            </MDTypography>
          )}
        </>
      ),
    },

    {
      field: "tax",
      headerName: "Tax",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.tax !== row?.firstMonthTax ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.tax)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthTax)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.tax)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "cityTax",
      headerName: "City Tax",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.cityTax !== row?.firstMonthCityTax ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.cityTax || 0)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthCityTax || 0)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.cityTax || 0)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "countyTax",
      headerName: "County Tax",
      width: 120,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.countyTax !== row?.firstMonthCountyTax ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.countyTax || 0)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthCountyTax || 0)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.countyTax || 0)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "serviceFee",
      headerName: "Service Fee",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {row.isApplyServiceFee ? `$${centsToDollars(row.serviceFee)}` : 0}
          </MDTypography>
        </>
      ),
    },
    {
      field: "paymentGatewayFee",
      headerName: "Payment Gateway Fee",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.paymentGatewayFee !== row?.firstMonthPaymentGatewayFee ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(
                    row.paymentGatewayFeePayBy === "customer"
                      ? row?.paymentGatewayFee
                      : 0,
                  )}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(
                    row.paymentGatewayFeePayBy === "customer"
                      ? row?.firstMonthPaymentGatewayFee
                      : 0,
                  )}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.paymentGatewayFee)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.totalAmount !== row?.firstMonthTotalAmount ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.totalAmount)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthTotalAmount)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.totalAmount)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "ownerPayout",
      headerName: "Owner Payout",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.ownerPayout !== row?.firstMonthOwnerPayout ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.ownerPayout)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthOwnerPayout)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.ownerPayout)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "dockRevenue",
      headerName: "Dock Revenue",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isMonthly &&
          row.renewalCount === 0 &&
          row?.dockRevenue !== row?.firstMonthDockRevenue ? (
            <>
              <Stack direction="row" spacing={1}>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light", textDecoration: "line-through" }}
                >
                  {`$${centsToDollars(row?.dockRevenue)}`}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="caption"
                  sx={{ color: "black.light" }}
                >
                  {`$${centsToDollars(row?.firstMonthDockRevenue)}`}
                </MDTypography>
              </Stack>
            </>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.light" }}
            >
              {`$${centsToDollars(row?.dockRevenue)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    ...(roleLevel === 100
      ? [
          {
            field: "dockTransfer",
            headerName: "Dock Transfer",
            width: 180,
            sortable: false,
            renderCell: ({ row }) => {
              if (row?.subscriptionStatus === "failed") {
                return (
                  <MDBadge
                    badgeContent="No Transfer"
                    color="secondary"
                    variant="gradient"
                    size="sm"
                  />
                );
              }

              // No transfer needed if no dock revenue
              if (!row?.dockRevenue || row?.dockRevenue <= 0) {
                return (
                  <MDBadge
                    badgeContent="No Transfer"
                    color="secondary"
                    variant="gradient"
                    size="sm"
                  />
                );
              }

              if (row?.dockTransferStatus === "success") {
                return (
                  <MDBadge
                    badgeContent={`Transferred (${row?.dockTransferRetryFrom || "Webhook"})`}
                    color="success"
                    variant="gradient"
                    size="sm"
                  />
                );
              }

              if (row?.dockTransferStatus === "failed") {
                return (
                  <Tooltip
                    title={
                      row?.dockTransferFailedReason ||
                      "Dock revenue transfer failed"
                    }
                  >
                    <MDBadge
                      badgeContent="Failed"
                      color="error"
                      variant="gradient"
                      size="sm"
                    />
                  </Tooltip>
                );
              }

              return (
                <MDBadge
                  badgeContent="Pending"
                  color="warning"
                  variant="gradient"
                  size="sm"
                />
              );
            },
          },
        ]
      : []),

    {
      field: "primaryConnectAccountPayout",
      headerName: "Client Payout",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {`$${centsToDollars(row.primaryConnectAccountPayout || 0)}`}
          </MDTypography>
        </>
      ),
    },
    {
      field: "secondaryConnectAccountPayout",
      headerName: "Operator Payout",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {`$${centsToDollars(row.secondaryConnectAccountPayout || 0)}`}
          </MDTypography>
        </>
      ),
    },
    ...(subscriptionType === "paused"
      ? [
          {
            field: "resumeDate",
            headerName: "Resume Date",
            width: 150,
            renderCell: ({ row }) => (
              <MDTypography
                display="block"
                F
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {dateToShow(row.resumeDate)}
              </MDTypography>
            ),
          },
        ]
      : []),
    {
      field: "actions",
      headerName: "Actions",
      width:
        subscriptionType === "active" || subscriptionType === "actionRequired"
          ? 450
          : subscriptionType === "pending"
            ? 350
            : subscriptionType === "expired" || subscriptionType === "failed"
              ? 350
              : 340,

      renderCell: ({ row }) => {
        const isActionTab = subscriptionType === "actionRequired";
        const status = row.subscriptionStatus;

        const isUpcomingRenewal =
          status === "active" &&
          row.isAutoRenew &&
          moment(row.endDate).isBetween(moment(), upcomingEndDate, "day", "[]");

        return (
          <>
            <Stack direction="row" alignItems="center" gap={2}>
              <Tooltip title="View Details" placement="top">
                <IconButton
                  color="success"
                  onClick={() => {
                    setDetailsDialogOpen(true);
                    setSubscriptionId(row._id);
                  }}
                >
                  <Icon fontSize="small">visibility</Icon>
                </IconButton>
              </Tooltip>

              <Tooltip
                title={`Impersonate To Parker Dashboard`}
                placement="left"
              >
                <MDButton
                  variant="gradient"
                  onClick={() => handelSwitch(row)}
                  fontSize="small"
                  color={sidenavColor}
                >
                  <SelfImprovementIcon />
                </MDButton>
              </Tooltip>

              {(subscriptionType === "active" ||
                (isActionTab &&
                  status === "active" &&
                  !row.isSubscriptionPaused)) && (
                <>
                  <Tooltip title={`Download Invoice`} placement="left">
                    <MDButton
                      variant="gradient"
                      fontSize="small"
                      color={sidenavColor}
                      onClick={() => handleDownloadInvoice(row.invoiceURL)}
                    >
                      <DownloadIcon />
                    </MDButton>
                  </Tooltip>
                </>
              )}

              {/* Send Reminder Email Button Handled via ConfirmationDialog */}
              {!row.isReminderEmailSend &&
                (subscriptionType === "upcoming" ||
                  (isActionTab && isUpcomingRenewal)) && (
                  <Tooltip title="Send Reminder Email" placement="top">
                    <MDButton
                      variant="gradient"
                      fontSize="small"
                      color={sidenavColor}
                      onClick={() => {
                        setSubscriptionId(row._id);
                        setReminderEmailDialogOpen(true);
                      }}
                    >
                      <EmailIcon />
                    </MDButton>
                  </Tooltip>
                )}

              {((subscriptionType === "paymentPending" &&
                row.paymentMethodType === "ACH") ||
                (isActionTab &&
                  status === "initialize" &&
                  row.paymentMethodType === "ACH")) && (
                <Tooltip title={`Charge This Subscription`} placement="top">
                  <MDButton
                    variant="gradient"
                    fontSize="small"
                    color={sidenavColor}
                    onClick={() => {
                      setSubscriptionData(row);
                      setChargeDialogOpen(true);
                    }}
                  >
                    <CurrencyExchangeIcon />
                  </MDButton>
                </Tooltip>
              )}

              {(subscriptionType === "expired" ||
                subscriptionType === "upcoming" ||
                (isActionTab &&
                  (status === "expired" ||
                    (row.isAutoRenew &&
                      !row.isSubscriptionPaused &&
                      new Date(row.endDate) < now) ||
                    isUpcomingRenewal))) && (
                <>
                  <Tooltip title={`Charge This Subscription`} placement="top">
                    <MDButton
                      variant="gradient"
                      fontSize="small"
                      color={sidenavColor}
                      onClick={() => {
                        setSubscriptionData(row);
                        setChargeDialogOpen(true);
                      }}
                    >
                      <CurrencyExchangeIcon />
                    </MDButton>
                  </Tooltip>
                </>
              )}

              {subscriptionType === "failed" && (
                <>
                  <Tooltip title={`Charge This Subscription`} placement="top">
                    <MDButton
                      variant="gradient"
                      fontSize="small"
                      color={sidenavColor}
                      onClick={() => {
                        setSubscriptionData(row);
                        setChargeDialogOpen(true);
                      }}
                    >
                      <CurrencyExchangeIcon />
                    </MDButton>
                  </Tooltip>
                </>
              )}

              {subscriptionType === "pending" && (
                <>
                  <Tooltip title={`Delete Subscription`} placement="top">
                    <IconButton
                      color="error"
                      onClick={() => {
                        setDialogOpen(true);
                        setSubscriptionId(row._id);
                        setSubscriptionData(row);
                      }}
                    >
                      <Icon fontSize="small">delete</Icon>
                    </IconButton>
                  </Tooltip>
                  {(() => {
                    const email = get(row, "customerId.email", "");
                    const mobile =
                      get(row, "customerId.mobile", "") ||
                      get(row, "customerId.secondaryMobile", "");
                    const hasEmail = Boolean(email && email.trim());
                    const hasMobile = Boolean(mobile && String(mobile).trim());

                    return (
                      <>
                        <Tooltip
                          title={
                            hasEmail
                              ? `Send Payment Link via Email (${email})`
                              : "No email address available"
                          }
                          placement="top"
                        >
                          <span style={{ display: "inline-block" }}>
                            <IconButton
                              color={sidenavColor}
                              disabled={!hasEmail}
                              onClick={() =>
                                handleOpenPaymentLinkDialog(row, "email")
                              }
                            >
                              <EmailIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={
                            hasMobile
                              ? `Send Payment Link via SMS (${mobile})`
                              : "No mobile number available (mobile or secondaryMobile)"
                          }
                          placement="top"
                        >
                          <span style={{ display: "inline-block" }}>
                            <IconButton
                              color={hasMobile ? "info" : "default"}
                              disabled={!hasMobile}
                              onClick={() =>
                                handleOpenPaymentLinkDialog(row, "sms")
                              }
                            >
                              <SmsIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </>
                    );
                  })()}
                  <Tooltip title={`Edit Email`} placement="top">
                    <IconButton
                      color="primary"
                      onClick={() => openEditEmailDialog(row)}
                    >
                      <Icon fontSize="small">edit</Icon>
                    </IconButton>
                  </Tooltip>
                </>
              )}

              {(subscriptionType === "active" ||
                subscriptionType === "paused" ||
                (isActionTab &&
                  (status === "active" ||
                    status === "paused" ||
                    row.isSubscriptionPaused))) && (
                <>
                  <Tooltip
                    title={`${
                      row?.isSubscriptionPaused ? "Resume" : "Pause"
                    } Subscription`}
                    placement="top"
                  >
                    <MDButton
                      variant="gradient"
                      fontSize="small"
                      color={sidenavColor}
                      onClick={() => {
                        setSubscriptionPauseView(true);
                        setIsSubscriptionPaused(
                          row.isSubscriptionPaused || false,
                        );
                        setSelectedSubscriptionIds([row._id]);
                      }}
                    >
                      {row?.isSubscriptionPaused ? (
                        <PlayCircle />
                      ) : (
                        <PauseCircle />
                      )}
                    </MDButton>
                  </Tooltip>
                </>
              )}
              {row?.dockTransferStatus === "failed" && row.dockRevenue > 0 && (
                <Tooltip title="Retry Dock revenue transfer" placement="top">
                  <MDButton
                    variant="gradient"
                    fontSize="small"
                    color={sidenavColor}
                    onClick={() => {
                      setRetryTransferData(row);
                      setRetryTransferDialog(true);
                    }}
                  >
                    <AutorenewIcon />
                  </MDButton>
                </Tooltip>
              )}
            </Stack>
          </>
        );
      },
    },
  ];

  const handelDelete = () => {
    setLoading(true);
    const targetPlaceId =
      placeData?._id ||
      placeData?.placeId ||
      selectedPlace?._id ||
      selectedPlace?.placeId ||
      subscriptionData?.placeId?._id ||
      subscriptionData?.placeId ||
      localStorage.getItem("placeId");

    dispatch(deleteSubscription(subscriptionId))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        if (success) {
          if (targetPlaceId) {
            await dispatch(getSubscriptionsByPlaceId(targetPlaceId));
          }
          setLoading(false);
          setDialogOpen(false);
        }
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        setLoading(false);
        setDialogOpen(false);
      })
      .catch((err) => {
        console.error("Error getting delete:", err);
        setNotification({
          ...notification,
          color: "error",
          title: "Error",
          content: err?.message || "Failed to delete subscription",
          icon: "warning",
          show: true,
        });
        setLoading(false);
        setDialogOpen(false);
      });
  };

  const handelRefund = () => {
    setLoading(true);
    const targetPlaceId =
      placeData?._id ||
      placeData?.placeId ||
      selectedPlace?._id ||
      selectedPlace?.placeId ||
      subscriptionData?.placeId?._id ||
      subscriptionData?.placeId ||
      localStorage.getItem("placeId");

    dispatch(paymentRefund(subscriptionId))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        if (success) {
          if (targetPlaceId) {
            await dispatch(getSubscriptionsByPlaceId(targetPlaceId));
          }
          setLoading(false);
          setConfirmationDialogOpen(false);
        }
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        setLoading(false);
        setConfirmationDialogOpen(false);
      })
      .catch((err) => {
        console.error("Error getting refund:", err);
        setNotification({
          ...notification,
          color: "error",
          title: "Error",
          content: err?.message || "Failed to refund subscription",
          icon: "warning",
          show: true,
        });
        setLoading(false);
        setConfirmationDialogOpen(false);
      });
  };

  const getRowClassName = (params) => {
    return params.row.licensePlateGetUpdated ? "updateAvailable" : "";
  };

  const handleOpenPaymentLinkDialog = (row, type) => {
    setSubscriptionId(row._id);
    setSubscriptionData(row);
    const recipient =
      type === "sms"
        ? get(row, "customerId.mobile", "") ||
          get(row, "customerId.secondaryMobile", "")
        : get(row, "customerId.email", "");
    setPaymentLinkDialog({
      open: true,
      type,
      recipient,
    });
  };

  const handleSendPaymentLink = async () => {
    try {
      setLoading(true);
      const res = await dispatch(
        sendPaymentLinkEmail({
          subscriptionId,
          type: paymentLinkDialog.type,
        }),
      ).unwrap();

      const success = res?.success;
      setNotification({
        ...notification,
        color: success ? "success" : "error",
        title: success ? "Success" : "Error",
        content:
          res?.message ||
          `Payment Link sent via ${
            paymentLinkDialog.type === "sms" ? "SMS" : "Email"
          }!`,
        icon: success ? "check" : "warning",
        show: true,
      });
      setLoading(false);
      setPaymentLinkDialog((prev) => ({ ...prev, open: false }));
    } catch (err) {
      console.error("Error sending payment link:", err);
      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: err?.message || "Failed to send payment link",
        icon: "warning",
        show: true,
      });
      setLoading(false);
      setPaymentLinkDialog((prev) => ({ ...prev, open: false }));
    }
  };

  // Send Reminder Email Handler
  const handelSendReminderEmail = async () => {
    setLoading(true);

    dispatch(sendReminderEmail({ subscriptionIds: [subscriptionId] }))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        if (success) {
          await dispatch(
            getSubscriptionsByPlaceId(placeData?._id || placeData?.placeId),
          );
          setLoading(false);
          setReminderEmailDialogOpen(false);
        }
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        setLoading(false);
        setReminderEmailDialogOpen(false);
      })
      .catch((err) => {
        console.error("Error sending reminder email:", err);
        setLoading(false);
        setReminderEmailDialogOpen(false);
        setNotification({
          ...notification,
          color: "error",
          title: "Error",
          content: "Failed to send reminder email.",
          icon: "warning",
          show: true,
        });
      });
  };

  return (
    <>
      <ConfirmationDialog
        title="Retry Dock Revenue Transfer"
        description="Are you sure you want to retry dock revenue transfer?"
        dialogOpen={retryTransferDialog}
        onClose={() => {
          setRetryTransferDialog(false);
          setRetryTransferData({});
        }}
        handelClick={handelRetryDockRevenueTransfer}
      />
      <MDBox mt={selectedSubscriptionIds.length > 0 ? 0 : 2}>
        {(subscriptionType === "active" ||
          subscriptionType === "paused" ||
          subscriptionType === "actionRequired") &&
          selectedSubscriptionIds.length > 0 && (
            <MDBox display="flex" justifyContent="end" mb={1}>
              <MDButton
                variant="contained"
                size="small"
                color={sidenavColor}
                onClick={() => {
                  setSubscriptionPauseView(true);
                }}
              >
                Action
              </MDButton>
            </MDBox>
          )}
        <MDDataGrid
          rows={!isEmpty(subscriptionList) ? subscriptionList : []}
          columns={columnsData}
          getRowId={(row) => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
          loading={isLoading}
          components={{
            NoRowsOverlay: EmptyTableRowOverlay,
            LoadingOverlay: LinearProgress,
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          // autoHeight
          getRowClassName={getRowClassName}
        />
      </MDBox>
      <ConfirmationDialog
        title="Delete Confirmation!"
        description="Are you sure you want to delete this subscription?"
        dialogOpen={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        handelClick={handelDelete}
      />
      <ConfirmationDialog
        title="Refund Confirmation!"
        description="Are you sure you want to refund this subscription?"
        dialogOpen={confirmationDialogOpen}
        onClose={() => {
          setConfirmationDialogOpen(false);
        }}
        handelClick={() => handelRefund()}
      />
      <ConfirmationDialog
        title={`Send payment link via ${
          paymentLinkDialog.type === "sms" ? "SMS" : "Email"
        }!`}
        description={`Are you sure you want to send the payment link via ${
          paymentLinkDialog.type === "sms" ? "SMS" : "Email"
        }${paymentLinkDialog.recipient ? ` to ${paymentLinkDialog.recipient}` : ""} ?`}
        dialogOpen={paymentLinkDialog.open}
        onClose={() => {
          setPaymentLinkDialog((prev) => ({ ...prev, open: false }));
        }}
        handelClick={handleSendPaymentLink}
      />

      <ConfirmationDialog
        title="Send Reminder Email!"
        description="Are you sure you want to send a reminder email for this upcoming renewal?"
        dialogOpen={reminderEmailDialogOpen}
        onClose={() => {
          setReminderEmailDialogOpen(false);
        }}
        handelClick={() => handelSendReminderEmail()}
      />

      <LicensePlateUpdateDialog
        dialogOpen={licensePlateUpdateDialog}
        onClose={() => {
          setLicensePlateUpdateDialog(false);
        }}
        subscription={subscriptionData}
      />
      <SubscriptionDetail
        subscriptionId={subscriptionId}
        dialogOpen={detailsDialogOpen}
        onClose={() => {
          setDetailsDialogOpen(false);
        }}
      />
      <SubscriptionChargeDialog
        subscriptionData={subscriptionData}
        dialogOpen={chargeDialogOpen}
        onClose={() => {
          setChargeDialogOpen(false);
          setSubscriptionData({});
        }}
      />
      <LicensePlatesDialog
        licensePlates={licensePlates}
        dialogOpen={licensePlateView}
        onClose={() => {
          setLicensePlateView(false);
        }}
      />
      <PauseDialog
        subscriptionIds={selectedSubscriptionIds}
        dialogOpen={subscriptionPauseView}
        isSubscriptionPaused={isSubscriptionPaused}
        onClose={() => {
          setSubscriptionPauseView(false);
          setSelectedSubscriptionIds([]);
        }}
        placeData={placeData}
      />

      <MDDialog
        dialogTitle={"Edit Customer Email"}
        dialogOpen={editEmailDialogOpen}
        dialogClose={() => setEditEmailDialogOpen(false)}
        maxWidth="sm"
      >
        <DialogContent dividers>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Current Email"
              value={editEmailForm.currentEmail}
              fullWidth
              size="small"
              disabled
            />
            <TextField
              label="New Email"
              value={editEmailForm.newEmail}
              fullWidth
              size="small"
              onChange={(e) =>
                setEditEmailForm({ ...editEmailForm, newEmail: e.target.value })
              }
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="end"
          >
            <MDTextButton onClick={() => setEditEmailDialogOpen(false)}>
              Cancel
            </MDTextButton>
            <MDButton
              size="small"
              variant="contained"
              color={sidenavColor}
              onClick={handleEditEmailSubmit}
              disabled={loading}
            >
              Save
            </MDButton>
          </Stack>
        </DialogActions>
      </MDDialog>

      <CircularIndeterminate
        type="full"
        size={20}
        text="Please wait..."
        open={loading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
    </>
  );
};

export default SubscriptionsTable;
